import { LimitType } from "model/schema/globalTypes";
import * as Yup from "yup";

export const notificationTriggersValidationSchema = Yup.array().of(
  Yup.object().shape({
    email: Yup.string()
      .trim()
      .required("Email is required")
      .email("Invalid email address"),
    thresholds: Yup.array()
      .min(1, "At least one threshold is required")
      .required("Thresholds are required")
  })
);

export const serviceProductValidationSchema = Yup.object().shape({
  apiKeyId: Yup.string().required("API Key ID is required"),
  limitType: Yup.string()
    .oneOf([LimitType.Soft, LimitType.Hard], "Invalid limit type")
    .required("Limit type is required"),
  transactionLimit: Yup.number()
    .integer("Transaction limit must be an integer")
    .positive("Transaction limit must be positive")
    .required("Transaction limit is required"),
  periods: Yup.array()
    .min(1, "Period is required")
    .test("periods-valid", "Period is required", value => {
      if (!value || value.length === 0) return false;
      const period = value[0];
      return !!period.startDate && !!period.endDate;
    }),
  services: Yup.array().min(1, "At least one service is required"),

  name: Yup.string().required("Name is required"),
  notificationTriggers: notificationTriggersValidationSchema,
  startMonth: Yup.string().when("singlePeriod", {
    is: false,
    then: schema => schema.required("Start month is required"),
    otherwise: schema => schema.notRequired()
  }),
  endMonth: Yup.string().when("singlePeriod", {
    is: false,
    then: schema => schema.required("End month is required"),
    otherwise: schema => schema.notRequired()
  })
});
